module.exports = __webpack_public_path__ + "img/user3.3094436a.png";